<template>
  <div class="col-2 h-20" @click="selectIcon()" :class="{ selected: isSelected }">
    <center>
      <img :src="require('../../assets/images/icons/' + image + '.png')" class="img-fluid">
    </center>
  </div>
</template>

<script>
export default {
  name: 'Selections',
  props: ['image', 'selectedIcons', 'showMessage'],
  data () {
    return {
      isSelected: false
    }
  },
  methods: {
    selectIcon () {
      this.$emit('update:showMessage', false)
      if (this.selectedIcons.indexOf(this.image) === -1 && this.selectedIcons.length < 3) {
        this.isSelected = !this.isSelected
        this.selectedIcons.push(this.image)
      } else if (this.selectedIcons.indexOf(this.image) !== -1) {
        this.selectedIcons.splice(this.selectedIcons.indexOf(this.image), 1)
        this.isSelected = !this.isSelected
      }
      this.$emit('update:selectedIcons', this.selectedIcons)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.h-20 {
  height: 15vh;
  vertical-align: middle;
  border: 2px solid transparent;
}
.img-fluid {
  max-height: 13vh;
}
.h-20.selected {
  height: 15vh;
  border: 2px solid rgb(0, 75, 141);
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/Selections.vue